module.exports = __webpack_public_path__ + "img/horizontal_2_1_8017.9ae21374.png";